(function ($, Promise) {

  // Constructor
  function VICCVisualizeShare() {
    // console.log("VICCShare: constructor()");

    this.isAnimating = false;
    this.currentHash = false;
    this.selectedDisaster = false;

    this.lastRequestedShare = false;
  }

  VICCVisualizeShare.prototype.attach = function (dom) {
    // console.log("VICCVisualizeShare: attach()");

    // Init Triggers
    this.initTrigger();

    if (app.currentComponent.constructor.name == "VICCVisualize") {
      $("#visualize-share #visualize-share-inner").off("scroll").on("scroll", $.proxy(function (e) {
        this.onScroll(e);
      }, this));
    } else {
      $(window).on("scroll", $.proxy(function (e) {
        this.onScroll(e);
      }, this));
    }
  }

  VICCVisualizeShare.prototype.initTrigger = function () {

    // Share on social medias
    $("#visualize-share-submit").off("click").on("click", $.proxy(function (e) {
      e.preventDefault();
      app.components["what-now"].submitReminderForm();
    }, this));

    // Open drawer
    $("#visualize-result-share").on("click", $.proxy(function () {
      this.openShareDrawer();
    }, this));

    // Close drawer
    $("#visualize-share #visualize-close-share").on("click", $.proxy(function () {
      this.closeShareDrawer();
    }, this));

    // Share on social medias
    $(".visualize-share-widget a").on("click", $.proxy(function (e) {
      this.openSocialPopup(e, $(e.currentTarget).data("type"));
    }, this));

    // Checkbox - Agree to make address visible
    $(".visualize-share-address + label").on("click", $.proxy(function (e) {
      if ($(e.currentTarget).prev().prop('checked')) {
        $(e.currentTarget).prev().prop('checked', false);
      } else {
        $(e.currentTarget).prev().prop('checked', true);
      }
    }, this));

    // Change disaster
    $("#visualize-share").on("click", ".visualize-result-disaster-selector li", $.proxy(function (e) {
      var disaster = $(e.currentTarget).data("disaster");
      $("#visualize-breadcrumb #breadcrumb-disaster-selector li[data-disaster='" + disaster + "']").trigger("click");
    }, this));

    // Back browser button
    $(window).on('popstate', $.proxy(function (e) {
      if (app.currentComponent.constructor.name == "VICCVisualize" && $("#visualize-share").is(".shown")) {
        if (window.location.hash == "") {
          this.closeShareDrawer();
        } else {
          VICC.prototype.scrollTo($(window.location.hash), "#visualize-share #visualize-share-inner", 20);
        }
      }
    }, this));

    // Radios
    $("#visualize-share .visualize-share-item.radio, #act-now .visualize-share-item.radio").on("click", $.proxy(function (e) {
      if ($(e.currentTarget).find("input[type='radio']").length) {
        $(e.currentTarget).find("input[type='radio']").prop('checked', true);
        $(e.currentTarget).siblings().removeClass("checked").find("input[type='radio']").prop('checked', false);
        $(e.currentTarget).addClass("checked");
      }

      // Copy to clipboard for sharing
      if ($(e.currentTarget).find(".clipboard-notify").length) {
        var messageToCopy = $(e.currentTarget).find("label").text();
        this.updateClipboard(messageToCopy, function () {
          // Add class
          $(e.currentTarget).addClass("copied");
          // Remove class
          setTimeout(function () {
            $(e.currentTarget).removeClass("copied");
          }, 2000);
        });
      }
    }, this));

    // Checkbox
    $("#visualize-share .visualize-share-item.checkbox, #act-now .visualize-share-item.checkbox").on("click", function (e) {
      var isChecked = !$(this).find("input[type='checkbox']").is(":checked");
      $(this).toggleClass("checked", isChecked);
      $(this).find("input[type='checkbox']").prop('checked', isChecked);
    });

  }

  VICCVisualizeShare.prototype.openShareDrawer = function () {
    if (!this.isAnimating) {
      this.isAnimating = true;

      // Update active menu item
      $("#header a[href*='what-now']:not(.language-switcher), #mobile-menu a[href*='what-now']:not(.language-switcher)").addClass("active prevent-default disable-barba").siblings().removeClass("active");
      history.pushState({}, null, window.location.origin + window.location.pathname + "#drawer-open");

      $("#visualize-share").addClass("shown");

      setTimeout($.proxy(function () {
        $("body").addClass("disable-scroll");
        this.isAnimating = false;

        // Refresh inView elements
        inView('.in-view').check();
      }, this), 400);
    }
  }

  VICCVisualizeShare.prototype.closeShareDrawer = function () {
    if (!this.isAnimating) {
      this.isAnimating = true;

      // Update active menu item
      $("#header a[href*='what-now'], #mobile-menu a[href*='what-now']").removeClass("prevent-default disable-barba");
      $("#header a[href*='visualize'], #mobile-menu a[href*='visualize']").addClass("active").siblings().removeClass("active");
      window.history.replaceState("", null, window.location.origin + window.location.pathname);

      $("#visualize-share").removeClass("shown");
      $("body").removeClass("disable-scroll");

      // Keep same scroll
      requestAnimationFrame($.proxy(function () {
        window.scrollTo(0, document.body.scrollHeight);
      }, this));

      setTimeout($.proxy(function () {
        this.isAnimating = false;
      }, this), 400);
    }

  }

  VICCVisualizeShare.prototype.openSocialPopup = function (e, type) {
    e.preventDefault();

    $(".visualize-socials").addClass("loading")

    var displayAddress = $(e.currentTarget).parents(".visualize-share-widget").find(".visualize-share-address").is(':checked');
    var address = (app.currentComponent.placename) ? app.currentComponent.placename : "";

    // Request a sharing URL to the API
    this.requestShareUrl(this.currentHash, this.selectedDisaster, displayAddress, address).then(function (shareId) {

      // Define the shared url
      var sharedUrl = window.location.origin + "/" + app.language;
      if (shareId !== false) {
        sharedUrl += "/share/" + shareId;
      }

      // Display the sharing popup
      var popupFullURL = $(e.currentTarget).attr("href") + sharedUrl;
      var left = (window.screen.width / 2) - (600 / 2);
      var top = (window.screen.height / 2) - (400 / 2);
      var preFilledMessage = ($(".visualize-share-message").length) ? $(".visualize-share-message").text() : "";

      // Add twitter prefilled message
      // This is now handled in HTML
      // if (type == "twitter") {
      //   popupFullURL += "&text=" + encodeURIComponent(preFilledMessage);
      // }

      if (type && $.inArray(type, ["email", "copy-to-clipboard"]) === -1) {
        // Facebook, twitter, linkedin
        window.open(popupFullURL, "popupWindow", "width=600, height=400, scrollbars=no, top=" + top + ", left=" + left + "");
      } else if (type === "email") {
        if (navigator.share) {
          // the url is added automatically at the end of the message
          navigator.share({
            title: document.title,
            text: preFilledMessage,
            url: sharedUrl,
          }).then(() => {
          }).catch(console.error);
        } else {
          // fallback
          window.open($(e.currentTarget).attr("href") + "%0D%0A" + sharedUrl);
        }
      } else if (type === "copy-to-clipboard") {
        this.updateClipboard(sharedUrl, function () {
          // Add class
          $(e.currentTarget).addClass("copied");
          // Remove class
          setTimeout(function () {
            $(e.currentTarget).removeClass("copied");
          }, 2000);
        });
      } else {
        // nothing
      }

    }.bind(this)).catch(function (e) {
      console.error("Error creating sharing URL.")

    }).finally(function () {
      $(".visualize-socials").removeClass("loading")
    })
  }

  VICCVisualizeShare.prototype.requestShareUrl = function (hash, selectedDisaster, displayAddress, address) {
    return new Promise($.proxy(function (resolve, reject) {

      if (hash == null || hash == false || $.inArray(selectedDisaster, ["flood", "wildfire", "smog"]) == -1) {
        resolve(false);
        return;
      }

      if ((this.lastRequestedShare != false) && (this.lastRequestedShare.hash == hash) && (this.lastRequestedShare.selectedDisaster == selectedDisaster) && (this.lastRequestedShare.displayAddress == displayAddress) && (this.lastRequestedShare.address == address)) {
        resolve(this.lastRequestedShare.savedId);
        return;
      }

      jqxr = $.ajax({
        type: "POST",
        url: "/api/share",
        data: {
          hash: hash,
          selectedDisaster: selectedDisaster,
          displayAddress: displayAddress,
          address: displayAddress ? address : '',
        },
        dataType: 'json'
      }).then($.proxy(function (responseJSON) {
        if (responseJSON.savedId) {
          this.lastRequestedShare = {
            hash: hash,
            selectedDisaster: selectedDisaster,
            displayAddress: displayAddress,
            address: address,
            savedId: responseJSON.savedId,
          };
          resolve(responseJSON.savedId);

        } else {
          reject()
        }

      }, this)).catch($.proxy(function (err) {
        reject(err)
      }, this));

    }, this));
  }

  VICCVisualizeShare.prototype.updateClipboard = function (newClip, callback) {

    var $textArea = $("<textarea>" + newClip + "</textarea>").css({
      "position": "fixed",
      "opacity": "0",
      "left": "-999999px",
      "top": "-999999px"
    });

    $("body").append($textArea);
    $textArea.focus().select();

    document.execCommand('copy')
    $textArea.remove();

    if (callback && typeof callback == "function") {
      callback();
    }
  }

  VICCVisualizeShare.prototype.onScroll = function (e) {

    var offset = $("#header").outerHeight() + 21;
    var bottomCalculation = e.currentTarget.toString() === "[object Window]" ? $(window).scrollTop() + $(window).height() == $(document).height() : $(e.currentTarget)[0].scrollTop >= ($(e.currentTarget)[0].scrollHeight - $(e.currentTarget)[0].offsetHeight);

    // Highlight menu item based on scroll position
    $('#sidebar-menu a[href^="#"]').each(function () {
      var anchor = $(this).attr('href');
      var targetY = $(anchor)[0].getBoundingClientRect().y - offset;

      if (bottomCalculation) {
        // When user scroll at the bottom
        $('#sidebar-menu a[href^="#"]').removeClass("active");

        if ($(this).attr("href") == "#visualize-process") {
          // This element is on multiple menu item
          $('#sidebar-menu a[href="#visualize-process"].selected').addClass("active");
        } else {
          $('#sidebar-menu a[href^="#"]:last-child').addClass("active");
        }
      } else if (targetY <= 0) {
        $('#sidebar-menu a[href^="#"]').removeClass("active")

        if ($(this).attr("href") == "#visualize-process") {
          // This element is on multiple menu item
          $('#sidebar-menu a[href="#visualize-process"].selected').addClass("active");
        } else {
          $(this).addClass('active');
        }
      } else {
        // none
        $(this).removeClass('active');
      }
    });
  }

  VICCVisualizeShare.prototype.dettach = function () {
    this.isAnimating = false;
    this.currentHash = false;
    this.selectedDisaster = false;

    $("body").removeClass("disable-scroll");

    $(window).off('popstate');
    $(window).off("scroll", $.proxy(this.onScroll, this));
    $("#visualize-share #visualize-share-inner").off("scroll", $.proxy(this.onScroll, this));
  }

  // Expose VICCShare
  window.VICCVisualizeShare = VICCVisualizeShare;

})(jQuery, Promise);
